import React from 'react';
import { PillContainer, PillVariant } from './pill.styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

type PillProps = {
  label: string;
  backgroundColor: string;
  color: string;
  variant: PillVariant;
  link?: {
    href: string;
    target?: string;
    rel?: string;
  };
};

const Pill: React.FC<PillProps> = ({ label, backgroundColor, color, variant, link }) => {
  const IS_ANCHOR = Boolean(link);
  const renderPillContent = (isAnchor: boolean) => {
    return (
      <PillContainer backgroundColor={backgroundColor} color={color} variant={variant}>
        <span>{label}</span>
        {isAnchor && <OpenInNewIcon />}
      </PillContainer>
    );
  };

  switch (IS_ANCHOR) {
    case true:
      return (
        <a href={link?.href} target={link?.target} rel={link?.rel}>
          {renderPillContent(IS_ANCHOR)}
        </a>
      );
    case false:
    default:
      return renderPillContent(IS_ANCHOR);
  }
};

export default Pill;
